// firebase の初期化ファイル
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB_6zid1iq48cXzTuSXkOh0AxI0BA5o74Y",
  authDomain: "katakana-yomeru.firebaseapp.com",
  projectId: "katakana-yomeru",
  storageBucket: "katakana-yomeru.appspot.com",
  messagingSenderId: "1043592270382",
  appId: "1:1043592270382:web:0f9d891cb31b1e68d605bf",
  measurementId: "G-DL3K241DBZ"

};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);